import { CouplesStorefrontDetails } from '~/types/storefrontDetails';
import { IUserContext } from '~/types/userContext';

import NAME, { NameFields } from '../../components/NameFields/NameFields';
import WEDDING_DATE, {
  NonVenueWeddingDate,
} from '../../components/NonVenueWeddingDateField/NonVenueWeddingDateField';
import { PhoneNumberField } from '../../components/PhoneNumberField/PhoneNumberField';
import { Question } from '../../components/Question/Question';
import BUDGET, { WeddingBudgetField } from '../../components/WeddingBudgetField/WeddingBudgetField';
import LOCATION, {
  WeddingLocationField,
} from '../../components/WeddingLocationField/WeddingLocationField';
import { useInquiryValues } from '../../context/InquiryContext';
import { LoadedInquiryValues } from '../../context/types';
import { InquiryFormValues } from '../../types';

const QUESTION_PARTS = [NAME, WEDDING_DATE, LOCATION, BUDGET];

export const FIELD_NAMES = QUESTION_PARTS.flatMap((part) => part.FIELD_NAMES);

export const VENUE_FIELD_NAMES = FIELD_NAMES.filter(
  (field) => !LOCATION.FIELD_NAMES.includes(field)
);

export const isAnswered = ({
  initialValues,
  storefront,
  userContext,
}: {
  initialValues: InquiryFormValues;
  storefront: CouplesStorefrontDetails;
  userContext: IUserContext | null;
}): boolean => {
  return QUESTION_PARTS.every((part) =>
    part.isAnswered({ initialValues, storefront, userContext })
  );
};

export const WeddingInfoQuestion = (): JSX.Element => {
  const { storefront } = useInquiryValues() as LoadedInquiryValues;
  const { name } = storefront;

  return (
    <Question
      hed={`Almost there! Just tell ${name} a bit more about you.`}
      instructions=" Add your wedding details below so you can have fewer back-and-forths with this vendor later."
    >
      <NameFields />

      <NonVenueWeddingDate />

      <WeddingLocationField />

      <WeddingBudgetField />

      <PhoneNumberField />
    </Question>
  );
};
